module.exports = __webpack_public_path__ + "8a5356e9/img/lock-icon.bb9c7166.svg";